import { pushGTMEvent } from 'utils/eventGTM';

const SignUpPanel = (): (() => void) => {
    const checkboxEl = document.querySelector('#checkbox-item-sign-up') as HTMLInputElement;
    const buttonEl = document.querySelector('.acknowledgment-cta') as HTMLButtonElement;

    const updateButtonState = (): void => {
        if (checkboxEl.checked) {
            buttonEl.removeAttribute('disabled');
            buttonEl.classList.remove('btn-disabled');
        } else {
            buttonEl.setAttribute('disabled', 'true');
            buttonEl.classList.add('btn-disabled');
        }
    };

    const formStartEvent = (): void => {
        pushGTMEvent({
            actionType: 'form_start',
            name: 'Sign up to MCC Plus form',
            type: 'Sign up',
        });
    };

    checkboxEl.addEventListener('change', updateButtonState);
    updateButtonState();
    formStartEvent();

    return () => {
        checkboxEl.removeEventListener('change', updateButtonState);
    };
};

export default SignUpPanel;
